<template>
  
  <div>
    <LoginForm />
  </div>
</template>

<script>
  import LoginForm from '@/views/general/components/LoginForm'

  export default {
    name: 'Login',
    components: {
      LoginForm
    },
    data() {
      return {
        //
      }
    },
    created() {
    }
  }
</script>